
class BESSAppProjectEditorFilters extends BESSAppBase {

    constructor(filtersNode, editor) {
        super();
        this.filtersNode = filtersNode;
        this.editor = editor;
    }

    reset() {
        this.filters = [
            new BESSAppProjectEditorFilterProjectWide(this.editor, this.filtersNode),
            new BESSAppProjectEditorFilterFields(this.editor, this.filtersNode),
            new BESSAppProjectEditorFilterBuilding(this.editor, this.filtersNode),
            new BESSAppProjectEditorFilterBuildingClassType(this.editor, this.filtersNode),
            new BESSAppProjectEditorFilterTag(this.editor, this.filtersNode),
        ]
        let showFilters = _.find(this.filters, (x) => x.valid) !== undefined;

        this.showViewIf(this.filtersNode, showFilters);

    }

    updateState(){
        this.forEach(this.filters, (filter) => filter.updateState());
        let showFilters = _.find(this.filters, (x) => x.valid) !== undefined;
        this.showViewIf(this.filtersNode, showFilters);
    }

    undo() {
        this.reset();
        this.forEach(this.filters, (filter) => filter.undo());
    }
}